import { IconWrapper } from '../runtime';
export default IconWrapper('lock-open', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M10.784 3.24477C10.4507 2.74497 9.4836 1.74951 7.9836 1.74951C6.4836 1.74951 4.75 2.96366 4.75 5.00388V6.75312M8 9.74981V11.2498M4.25 14.2501H11.75C12.5784 14.2501 13.25 13.5785 13.25 12.7501V8.25312C13.25 7.42469 12.5784 6.75312 11.75 6.75312H4.25C3.42157 6.75312 2.75 7.42469 2.75 8.25312V12.7501C2.75 13.5785 3.42157 14.2501 4.25 14.2501Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});